import React from "react";
import { Form, Field } from "react-final-form";
import html2canvas from "html2canvas";
import { Spin } from "antd";

const required = (value) => (value ? undefined : "Required");
const mustBeNumber = (value) => (isNaN(value) ? "Must be a number" : undefined);
const minLength = (value) =>
  value.length > 10 ? undefined : "Please Enter a Valid Phone Number";
const composeValidators =
  (...validators) =>
  (value) =>
    validators.reduce(
      (error, validator) => error || validator(value),
      undefined
    );

class OrderForm extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = { loading: false };
  }

  handleSubmit(values) {
    this.props.props.changeLoadingState();
    document.getElementById("designerDiv").scrollIntoView({ behavior: "smooth" });
    setTimeout(()=>{
    document.getElementById("scanner").style.display = "block";
    
  },1000)
    var  front, back;
    var frontCanvas = this.props.props.designer.frontCanvasJson;
    var backCanvas = this.props.props.designer.backCanvasJson;
    var canvasImages=[],canvasTexts=[];
    this.props.props.designer.drawingCanvas.getObjects().map(function(x){

      if(x.type==="text"){
        canvasTexts.push(x);
      }
      
        var url=x.toDataURL({
          format: 'png',
          multiplier: 7
        });
        canvasImages.push(url);
      
      });

    var props = this.props.props;

    html2canvas(document.querySelector("#shirtDiv"), { useCORS: true }).then(
      function (screenShot) {
        if (props.designer.showFrontView) {
          front = screenShot.toDataURL("image/png", 0.5);
        } else {
          back = screenShot.toDataURL("image/png", 0.5);
        }
      }
    );
    setTimeout(() => {
      props.onFlipImageClicked();
      props.designer.drawingCanvas.clear();
      if (props.designer.showFrontView) {
        props.designer.drawingCanvas.loadFromJSON(
          backCanvas
        );
      } else {
        props.designer.drawingCanvas.loadFromJSON(
          frontCanvas
        );
      }
      props.designer.drawingCanvas.renderAll();
      }, 2000);


    setTimeout(() => {
      props.designer.drawingCanvas.getObjects().map(function(x){

        if(x.type==="text"){
          canvasTexts.push(x);
        }
        
          var url=x.toDataURL({
            format: 'png',
            multiplier: 7
          });
          canvasImages.push(url);
        
        });
      html2canvas(document.querySelector("#shirtDiv"), {
        useCORS: true,
      }).then(function (screenShot) {
        if (props.designer.showFrontView) {
          back = screenShot.toDataURL("image/png", 0.5);
        } else {
          front = screenShot.toDataURL("image/png", 0.5);
        }
        document.getElementById("Loader").style.display = "block";

        props.handleFormSubmit({
          front: front,
          back: back,
          canvasTexts,
          canvasImages,
          details: { ...values,price:props.designer.price+20,measurment:props.designer.size },
        });
      });

    }, 4000);

  }
  render() {
    return (
        <Form
          onSubmit={this.handleSubmit}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <Spin spinning={this.props.props.designer.loader}>
            <div  style={{ marginTop: "30px" }}>
              <div className="checkout_title">Billing</div>

              <div className="checkout_form_container">
                <form onSubmit={handleSubmit}>
                  <Field name="firstName" validate={required}>
                    {({ input, meta }) => (
                      <div>
                                                {meta.error && meta.touched && (
                          <span style={{ color: "red" }}>{meta.error}</span>
                        )}
                        <input
                          {...input}
                          type="text"
                          id="checkout_name"
                          className="checkout_input"
                          placeholder="Name."
                        />

                      </div>
                    )}
                  </Field>

                  <Field name="Address" validate={required}>
                    {({ input, meta }) => (
                      <div>
                                                {meta.error && meta.touched && (
                          <span style={{ color: "red" }}>{meta.error}</span>
                        )}
                        <input
                          {...input}
                          type="text"
                          id="checkout_name"
                          className="checkout_input"
                          placeholder="Address."
                        />

                      </div>
                    )}
                  </Field>

                  <Field
                    name="phone"
                    validate={composeValidators(
                      required,
                      mustBeNumber,
                      minLength
                    )}
                  >
                    {({ input, meta }) => (
                      //         <div>
                      //   <label style={{fontWeight:"bold" , marginTop:"10px"}}>Phone</label>
                      //   <hr classNameName="rounded" style={{backgroundColor:"black",width:"60%",marginTop:"0px"}}/>
                      //   <input {...input} style={{background:"aliceblue",width:"100%",border:"1px solid black"}}/>
                      //   {meta.error && meta.touched && <span style={{color:"red"}}>{meta.error}</span>}

                      //         </div>
                      <div>
                                                {meta.error && meta.touched && (
                          <span style={{ color: "red" }}>{meta.error}</span>
                        )}
                        <input
                          {...input}
                          type="text"
                          id="checkout_name"
                          className="checkout_input"
                          placeholder="Phone No."
                        />

                      </div>
                    )}
                  </Field>

                  

                  <div className="checkout_button trans_200">
                    <button id="submitBtn" type="submit" disabled={submitting}>
                      Submit 
                    </button>
                  </div>
                </form>
              </div>
            </div>
                  </Spin>
          )}
        />    );
  }
}

export default OrderForm;
